export enum FilterType {
  all = "All Users",
  withoutOrg = "Users without Organization",
}